<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Inspecciones</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item active">Hse</li>
                  <li class="breadcrumb-item active">Operaciones</li>
                  <li class="breadcrumb-item active">Inspecciones</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <div class="card" style="display: inherit">
              <div class="card-header pt-2 pb-2">
                <div class="row">
                  <div class="col-md-11"></div>
                  <div class="col-md-1">
                    <div class="btn-group float-right">
                      <button
                        type="button"
                        class="btn bg-navy"
                        @input="getIndex()"
                      >
                        <i class="fas fa-sync"></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary"
                        v-if="$store.getters.can('hse.inspecciones.create')"
                        @click="save"
                      >
                        <i class="fas fa-plus"></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-success"
                        data-toggle="modal"
                        data-target="#modal_form_inspecciones_export"
                        v-if="$store.getters.can('hse.inspecciones.export')"
                      >
                        <i class="far fa-file-excel"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="card-body">
                  <h6>Filtros</h6>
                  <div class="row">
                    <div class="form-group col-md-2">
                      <label>Linea Negocio</label>
                      <select
                        class="form-control form-control-sm"
                        v-model="filtros.linea_negocio"
                        @input="getIndex()"
                      >
                        <option value="">Seleccione...</option>
                        <option value="3">Tif</option>
                        <option value="4">Carga Seca</option>
                        <option value="5">Tep</option>
                        <option value="8">Hse</option>
                      </select>
                    </div>
                    <div class="form-group col-md-2">
                      <label>N° Inspección</label>
                      <input
                        type="number"
                        v-model="filtros.id"
                        placeholder="N° inspeccion"
                        label="id"
                        class="form-control form-control-sm"
                        @input="getIndex()"
                      />
                    </div>
                    <div class="form-group col-md-4">
                      <label>Rango Fechas Inspección</label>
                      <div class="row">
                        <div class="col-md-6">
                          <input
                            type="date"
                            class="form-control form-control-sm"
                            v-model="filtros.fecha_inicio"
                            @change="getIndex()"
                          />
                        </div>
                        <div class="col-md-6">
                          <input
                            type="date"
                            class="form-control form-control-sm"
                            v-model="filtros.fecha_fin"
                            @change="getIndex()"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-2">
                      <label for="Fecha">Fecha Vencimiento</label>
                      <input
                        type="date"
                        class="form-control form-control-sm"
                        placeholder="Fecha Vencimiento"
                        v-model="filtros.fecha_vencimiento"
                        @change="getIndex()"
                      />
                    </div>
                    <div class="form-group col-md-4">
                      <label>Empresa</label>
                      <v-select
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="listasForms.slct_empresa"
                        placeholder="Empresas"
                        label="razon_social"
                        class="form-control form-control-sm p-0"
                        :options="empresas"
                        :filterable="false"
                        @search="buscarEmpresas"
                        @input="getIndex()"
                      ></v-select>
                    </div>
                    <div class="form-group col-md-2">
                      <label>Vehículo</label>
                      <input
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="filtros.placa_vehiculo"
                        placeholder="Placa"
                        label="placa"
                        class="form-control form-control-sm p-0"
                        :filterable="false"
                        @change="getIndex()"
                      />
                    </div>
                    <div class="form-group col-md-2">
                      <label>Remolque</label>
                      <v-select
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="listasForms.slct_remolque"
                        placeholder="Placa"
                        label="placa"
                        class="form-control form-control-sm p-0"
                        :options="remolques"
                        :filterable="false"
                        @search="buscarRemolques"
                        @input="getIndex()"
                      ></v-select>
                    </div>
                    <div class="form-group col-md-2">
                      <label>Estado</label>
                      <select
                        class="form-control form-control-sm"
                        v-model="filtros.estado"
                        @change="getIndex()"
                      >
                        <option value>Seleccione...</option>
                        <option
                          v-for="estado in listasForms.estados"
                          :key="estado.numeracion"
                          :value="estado.numeracion"
                        >
                          {{ estado.descripcion }}</option
                        >
                      </select>
                    </div>
                    <div class="form-group col-md-2">
                      <label>Estado Documento</label>
                      <select
                        class="form-control form-control-sm"
                        v-model="filtros.estado_documento"
                        @change="getIndex()"
                      >
                        <option value>Seleccione...</option>
                        <option
                          v-for="estado in listasForms.estados_documentos"
                          :key="estado.numeracion"
                          :value="estado.numeracion"
                          >{{ estado.descripcion }}</option
                        >
                      </select>
                    </div>
                  </div>
                </div>
                <div class="card-body p-0">
                  <table
                    class="table table-bordered table-striped table-hover table-sm"
                    style="font-size: 0.85em"
                  >
                    <thead class="thead">
                      <tr>
                        <th>N° Inspección</th>
                        <th>
                          Fecha Inspección
                        </th>
                        <th>Fecha Vencimiento</th>
                        <th>
                          Formato
                        </th>
                        <th>
                          Empresa
                        </th>
                        <th>
                          Vehículo
                        </th>
                        <th>
                          Remolque
                        </th>
                        <th>
                          Linea Negocio
                        </th>
                        <th style="width: 30px">
                          Estado
                        </th>
                        <th style="width: 30px">
                          Est. Doc
                        </th>
                        <th class="text-center">Acción</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="inspeccion in inspecciones.data"
                        :key="inspeccion.id"
                      >
                        <td>{{ inspeccion.id }}</td>
                        <td>{{ inspeccion.fecha_inicio }}</td>
                        <td>
                          {{ inspeccion.fecha_vencimiento }}-{{
                            inspeccion.hora_vencimiento
                          }}
                        </td>
                        <td>
                          {{
                            inspeccion.formato_inspeccion
                              ? inspeccion.formato_inspeccion.nombre
                              : ""
                          }}
                        </td>
                        <td>
                          {{
                            inspeccion.Empresa
                              ? inspeccion.Empresa
                              : inspeccion.empresa
                              ? inspeccion.empresa.razon_social
                              : ""
                          }}
                        </td>
                        <td>
                          {{
                            inspeccion.placa_vehiculo
                              ? inspeccion.placa_vehiculo
                              : inspeccion.vehiculo
                              ? inspeccion.vehiculo.placa
                              : ""
                          }}
                        </td>
                        <td>
                          {{
                            inspeccion.remolque ? inspeccion.remolque.placa : ""
                          }}
                        </td>
                        <td class="text-center">
                          <span class="badge badge-primary">{{
                            inspeccion.lineas_negocio
                              ? inspeccion.lineas_negocio.nombre
                              : inspeccion.formato_inspeccion
                                  .linea_negocio_id == 3
                              ? "Transporte Interno"
                              : inspeccion.formato_inspeccion
                                  .linea_negocio_id == 4
                              ? "Carga Seca"
                              : inspeccion.formato_inspeccion
                                  .linea_negocio_id == 5
                              ? "Transporte Especial Pasajeros"
                              : ""
                          }}</span>
                        </td>

                        <td class="text-center">
                          <span
                            class="badge"
                            :class="[
                              inspeccion.estado == 1
                                ? 'badge-secondary'
                                : inspeccion.estado == 2
                                ? 'badge-success'
                                : inspeccion.estado == 3
                                ? 'badge-warning'
                                : inspeccion.estado == 4
                                ? 'badge-danger'
                                : inspeccion.estado == 5
                                ? 'bg-olive'
                                : '',
                            ]"
                          >
                            {{
                              inspeccion.estado == 1
                                ? "Creada"
                                : inspeccion.estado == 2
                                ? "Aprobada"
                                : inspeccion.estado == 3
                                ? "Autorizada"
                                : inspeccion.estado == 5
                                ? "Aprobada con novedad"
                                : "Rechazada"
                            }}
                          </span>
                        </td>
                        <td class="text-center">
                          <span
                            class="badge"
                            :class="[
                              inspeccion.estado_documento == 1
                                ? 'badge-warning'
                                : 'badge-success',
                            ]"
                          >
                            {{
                              inspeccion.estado_documento == 1
                                ? "Borrador"
                                : "Definitivo"
                            }}
                          </span>
                        </td>
                        <td style="width: 50px" class="text-right">
                          <div class="btn-group float-right">
                            <button
                              type="button"
                              class="btn btn-sm bg-navy"
                              v-if="
                                $store.getters.can('hse.inspecciones.update')
                              "
                              @click="edit(inspeccion.id)"
                            >
                              <i class="fas fa-edit"></i>
                            </button>
                            <button
                              type="button"
                              class="btn btn-sm bg-danger"
                              v-if="$store.getters.can('hse.inspecciones.pdf')"
                              @click="verPDF(inspeccion.id)"
                            >
                              <i class="fas fa-file-pdf"></i>
                            </button>
                            <button
                              type="button"
                              class="btn btn-sm bg-info"
                              data-toggle="modal"
                              data-target="#modal-form-fecha"
                              style="cursor: pointer"
                              v-if="
                                $store.getters.can(
                                  'hse.inspecciones.cambioFecha'
                                )
                              "
                              @click="modalFechas(inspeccion)"
                            >
                              <i class="fas fa-calendar-plus"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="card-footer">
                  <div class="float-left" v-if="inspecciones.total">
                    <p>
                      Mostrando del
                      <b>{{ inspecciones.from }}</b> al
                      <b>{{ inspecciones.to }}</b> de un total:
                      <b>{{ inspecciones.total }}</b> Registros
                    </p>
                  </div>
                  <div class="float-left" v-else>
                    <p>
                      <span class="badge badge-danger"
                        >No hay registros para mostrar</span
                      >
                    </p>
                  </div>
                  <pagination
                    :data="inspecciones"
                    @pagination-change-page="getIndex"
                    :limit="5"
                    align="right"
                  >
                  </pagination>
                </div>
              </div>
            </div>
          </div>
          <HseInspeccionesExport ref="HseInspeccionesExport" />
          <HseInspeccionFechas ref="HseInspeccionFechas" />
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import pagination from "laravel-vue-pagination";
import vSelect from "vue-select";
import Loading from "../../../components/Loading";
import HseInspeccionesExport from "../inspecciones/HseInspeccionesExport";
import HseInspeccionFechas from "../inspecciones/HseInspeccionFechas";
export default {
  name: "InspeccionIndex",

  components: {
    Loading,
    pagination,
    vSelect,
    HseInspeccionesExport,
    HseInspeccionFechas,
  },
  data() {
    return {
      cargando: true,
      inspecciones: {},
      filtros: {
        linea_negocio: null,
        id: null,
        viaje_id: null,
        fecha_inicio: null,
        fecha_fin: null,
        formato_inspeccion_id: null,
        empresa_id: null,
        placa_vehiculo: null,
        remolque_id: null,
        conductor_id: null,
        estado: null,
        estado_documento: null,
      },
      listasForms: {
        slct_formato_inspeccion: [],
        slct_puntos_gestion: [],
        slct_empresa: [],
        slct_remolque: [],
        slct_conductor: [],
        estados: [],
        estados_documentos: [],
      },
      formatos_inspeccion: [],
      puntos_gestion: [],
      empresas: [],
      remolques: [],
      conductores: [],
    };
  },
  methods: {
    async getIndex(page = 1) {
      this.cargando = true;
      // Filtro para Formato de Inspección
      this.filtros.formato_inspeccion_id = null;
      if (this.listasForms.slct_formato_inspeccion) {
        this.filtros.formato_inspeccion_id = this.listasForms.slct_formato_inspeccion.id;
      }

      // Filtro para Empresa
      this.filtros.empresa_id = null;
      if (this.listasForms.slct_empresa) {
        this.filtros.empresa_id = this.listasForms.slct_empresa.id;
      }

      // Filtro para Remolques
      this.filtros.remolque_id = null;
      if (this.listasForms.slct_remolque) {
        this.filtros.remolque_id = this.listasForms.slct_remolque.id;
      }

      // Filtro para Conductores
      this.filtros.conductor_id = null;
      if (this.listasForms.slct_conductor) {
        this.filtros.conductor_id = this.listasForms.slct_conductor.id;
      }

      // Se valida que la fecha de finalización no sea menor que la fecha de inicio
      if (this.filtros.fecha_inicio && this.filtros.fecha_fin) {
        this.validaFechas();
      }

      axios
        .get("/api/tif/inspecciones?page=" + page, {
          params: await this.filtros,
        })
        .then((response) => {
          this.inspecciones = response.data;
          this.cargando = false;
        });
    },

    validaFechas() {
      const fecha_menor = new Date(this.filtros.fecha_inicio);
      const fecha_mayor = new Date(this.filtros.fecha_fin);
      // Se valida que la fecha inicial sea menor que la fecha final
      if (fecha_menor > fecha_mayor) {
        this.filtros.fecha_fin = null;
        this.$swal({
          icon: "error",
          title: `La fecha inicio no puede ser mayor a la fecha fin...`,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      }
    },

    buscarSitios(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "api/tif/inspecciones/sitios?lugar=" + search;
        axios
          .get(url)
          .then(function(response) {
            let respuesta = response.data;
            me.sitios = respuesta;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarFormatosInspeccion(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url =
          "api/admin/formatosInspeccion/lista?formato_inspeccion=" + search;
        axios
          .get(url)
          .then(function(response) {
            let respuesta = response.data;
            me.formatos_inspeccion = respuesta;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarEmpresas(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "api/admin/empresas/lista?razon=" + search;
        axios
          .get(url)
          .then(function(response) {
            let respuesta = response.data;
            me.empresas = respuesta;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrió un error - " + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarRemolques(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "api/admin/remolques/lista?placa=" + search;
        axios
          .get(url)
          .then(function(response) {
            me.remolques = response.data;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrió un error - " + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    getEstados() {
      axios.get("/api/lista/38").then((response) => {
        this.listasForms.estados = response.data;
      });
    },

    getEstadosDocumentos() {
      axios.get("/api/lista/28").then((response) => {
        this.listasForms.estados_documentos = response.data;
      });
    },

    save() {
      return this.$router.push({
        name: "/Hse/InspeccionesForm",
      });
    },

    edit(inspeccion_id) {
      return this.$router.push({
        name: "/Hse/InspeccionesForm",
        params: {
          inspeccion_id: inspeccion_id,
        },
      });
    },

    verPDF(inspeccion_id) {
      this.cargando = true;
      axios({
        method: "get",
        url: "/api/tif/inspecciones/pdf/" + inspeccion_id,
      })
        .then((response) => {
          let data = response.data;
          this.cargando = false;
          window.open(data.url, "_blank");
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },

    modalFechas(inspeccion) {
      if (this.$store.getters.can("hse.inspecciones.cambioFecha")) {
        this.$refs.HseInspeccionFechas.llenar_modal(inspeccion);
      }
    },
  },
  async mounted() {
    await this.getIndex();
    await this.getEstados();
    await this.getEstadosDocumentos();
  },
};
</script>
